var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBellRinging(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76855 10.5002C5.76608 9.61461 5.93837 8.73727 6.27554 7.91841C6.61271 7.09956 7.10815 6.35528 7.73346 5.72822C8.35876 5.10116 9.10166 4.60365 9.91957 4.26419C10.7375 3.92474 11.6143 3.75 12.4999 3.75C13.3854 3.75 14.2623 3.92474 15.0802 4.26419C15.8981 4.60365 16.641 5.10116 17.2663 5.72822C17.8916 6.35528 18.3871 7.09956 18.7242 7.91841C19.0614 8.73727 19.2337 9.61461 19.2312 10.5002V10.5002C19.2312 13.8579 19.9337 15.8063 20.5524 16.8712C20.6191 16.985 20.6546 17.1144 20.6553 17.2463C20.656 17.3781 20.6219 17.5078 20.5565 17.6223C20.491 17.7368 20.3966 17.8321 20.2826 17.8984C20.1686 17.9647 20.0392 17.9998 19.9073 18.0002H5.09173C4.95985 17.9998 4.83038 17.9647 4.7164 17.8984C4.60242 17.832 4.50795 17.7368 4.44252 17.6223C4.3771 17.5077 4.34303 17.378 4.34376 17.2461C4.34449 17.1142 4.37999 16.9849 4.44667 16.8711C5.06573 15.8061 5.76855 13.8577 5.76855 10.5002H5.76855Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18V18.75C9.5 19.5456 9.81607 20.3087 10.3787 20.8713C10.9413 21.4339 11.7044 21.75 12.5 21.75C13.2956 21.75 14.0587 21.4339 14.6213 20.8713C15.1839 20.3087 15.5 19.5456 15.5 18.75V18",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6973 2.24902C19.2234 3.21245 20.4536 4.57885 21.2521 6.19736",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74805 6.19736C4.54657 4.57885 5.77679 3.21245 7.30291 2.24902",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBellRinging);
export default __webpack_public_path__ + "static/media/icon-bell-ringing.a8408377c0d5aca0ba13b19ee6ab7c0f.svg";
export { ForwardRef as ReactComponent };